// Badge definitions. Each badge is awarded once and persists forever via
// useAppStore (localStorage). The `check` function receives the evaluation
// context produced by badgeEngine.evaluate() and returns whether the badge
// has been earned at this point in time.

export const BADGES = [
  {
    id: 'first_card',
    name: 'First Step',
    description: 'Reviewed your first card',
    icon: '🎯',
    tier: 'bronze',
    check: (ctx) => ctx.totalCardsReviewed >= 1,
  },
  {
    id: 'streak_7',
    name: 'Warm Streak',
    description: '7-day study streak',
    icon: '🔥',
    tier: 'bronze',
    check: (ctx) => ctx.longestStreak >= 7,
  },
  {
    id: 'streak_30',
    name: 'Blazing Streak',
    description: '30-day study streak',
    icon: '🔥',
    tier: 'silver',
    check: (ctx) => ctx.longestStreak >= 30,
  },
  {
    id: 'streak_100',
    name: 'Legendary Streak',
    description: '100-day study streak',
    icon: '👑',
    tier: 'gold',
    check: (ctx) => ctx.longestStreak >= 100,
  },
  {
    id: 'cards_100',
    name: 'Centurion',
    description: '100 cards reviewed',
    icon: '💯',
    tier: 'bronze',
    check: (ctx) => ctx.totalCardsReviewed >= 100,
  },
  {
    id: 'cards_1000',
    name: 'Quick Mind',
    description: '1,000 cards reviewed',
    icon: '⚡',
    tier: 'silver',
    check: (ctx) => ctx.totalCardsReviewed >= 1000,
  },
  {
    id: 'cards_10000',
    name: 'Encyclopedia',
    description: '10,000 cards reviewed',
    icon: '📚',
    tier: 'gold',
    check: (ctx) => ctx.totalCardsReviewed >= 10000,
  },
  {
    id: 'perfect_day',
    name: 'Perfect Recall',
    description: '100% on a session of 10+ cards',
    icon: '✨',
    tier: 'silver',
    check: (ctx) => ctx.sessionPerfect,
  },
  {
    id: 'subject_specialist',
    name: 'Subject Specialist',
    description: 'Mastered every card in a GCSE deck',
    icon: '🎓',
    tier: 'gold',
    check: (ctx) => ctx.gcseDecksMastered >= 1,
  },
  {
    id: 'night_owl',
    name: 'Night Owl',
    description: 'Studied between midnight and 4 AM',
    icon: '🦉',
    tier: 'bronze',
    check: (ctx) => ctx.studiedAtHour >= 0 && ctx.studiedAtHour < 4,
  },
  {
    id: 'early_bird',
    name: 'Early Bird',
    description: 'Studied before 6 AM',
    icon: '🌅',
    tier: 'bronze',
    check: (ctx) => ctx.studiedAtHour >= 4 && ctx.studiedAtHour < 6,
  },
  {
    id: 'comeback_kid',
    name: 'Comeback Kid',
    description: 'Returned after a 7+ day break',
    icon: '💪',
    tier: 'silver',
    check: (ctx) => ctx.comeback,
  },
  {
    id: 'polyglot',
    name: 'Polyglot',
    description: 'Studied 3+ language decks (FR / ES / DE)',
    icon: '🌍',
    tier: 'silver',
    check: (ctx) => ctx.languageDecksStudied >= 3,
  },
];

export function getBadge(id) {
  return BADGES.find(b => b.id === id) || null;
}
